import Lara from "@/presets/lara";

/**
 * Carousel pass-through: bottom page indicator styled as a scrollbar (track + thumb).
 * `primaryButtonBgClass` sets the prev/next button background so it follows storefront branding
 * (pass `primaryColorClassBG` from useTenantTheming); defaults to the API primary.
 */
export const carouselScrollbarPreset = (primaryButtonBgClass = "bg-university-primary") => ({
  ...Lara.carousel,
  indicators: {
    class: ["flex flex-row justify-center items-center gap-1", "h-2 rounded-full", "p-0.5", "mt-4"],
  },
  indicator: {
    class: ["mr-2 mb-2"],
  },
  indicatorbutton: ({ context }: { context: { highlighted: boolean } }) => ({
    class: [
      "w-8 h-2 rounded-full transition-colors duration-200",
      "focus:outline-none focus:outline-offset-0 focus:ring focus:ring-gray-500/50",
      {
        "bg-gray-400 hover:bg-gray-500": !context.highlighted,
        "bg-gray-650 hover:bg-gray-700": context.highlighted,
      },
    ],
  }),
  itemscontent: {
    class: [
      // Overflow & Width
      "overflow-hidden w-full h-full z-10",
    ],
  },
  content: {
    class: [
      // Flexbox & Overflow
      "flex flex-col overflow-hidden",
    ],
  },
  container: ({ props }) => ({
    class: [
      // Flexbox
      "relative flex",

      // Orientation
      {
        "flex-row": props.orientation !== "vertical",
        "flex-col": props.orientation === "vertical",
      },
    ],
  }),
  previousbutton: {
    class: [
      // Position: vertically anchored to the card's image/text seam via the custom property the
      // section measures; `-translate-y-1/2` centres the circle on it.
      "absolute left-0 z-20 top-[var(--carousel-nav-top)] -translate-y-1/2",

      // Sizing & Overflow
      "overflow-hidden w-8 h-8",

      // Shape
      "rounded-full",

      // Border & Background
      `border-0 ${primaryButtonBgClass}`,

      // Color
      "text-white",

      // Transitions
      "transition duration-200 ease-in-out",
    ],
  },
  previousbuttonicon: {
    class: ["flex w-full justify-center items-center self-center"],
  },
  nextbutton: {
    class: [
      // Position: see `previousbutton` — same seam anchor, opposite edge.
      "absolute right-0 z-20 top-[var(--carousel-nav-top)] -translate-y-1/2",

      // Sizing & Overflow
      "overflow-hidden w-8 h-8",

      // Shape
      "rounded-full",

      // Border & Background
      `border-0 ${primaryButtonBgClass}`,

      // Color
      "text-white",

      // Transitions
      "transition duration-200 ease-in-out",
    ],
  },
  nextbuttonicon: {
    class: ["flex w-full justify-center items-center self-center"],
  },
});

export const excursionIncludedSectionPresets = {
  ...Lara,
};
